import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            About Our Clinic
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto px-4 sm:px-6">
            We are dedicated to providing exceptional dental and cosmetology services
            with a focus on patient comfort and satisfaction.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12 items-center">
          {/* Image Section */}
          <div className="relative px-4 sm:px-0">
            <img
              src="https://images.unsplash.com/photo-1629909615184-74f495363b67?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2088&q=80"
              alt="Modern Dental Clinic"
              className="rounded-lg shadow-xl w-full h-auto object-cover"
            />
          </div>

          {/* Content Section */}
          <div className="space-y-4 sm:space-y-6 px-4 sm:px-0">
            <div>
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-3 sm:mb-4">
                Our Mission
              </h3>
              <p className="text-base sm:text-lg text-gray-600 text-justify">
                At Auradent, we believe confidence is the foundation of a beautiful life. Our mission is to provide cutting-edge dental and aesthetic treatments that are painless,
                effective, and designed to enhance your natural beauty; so you walk out not just looking your best, but feeling unstoppable!
              </p>
            </div>

            <div>
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-3 sm:mb-4">
                Our Vision
              </h3>
              <p className="text-base sm:text-lg text-gray-600 text-justify">
                To be the leading dental and cosmetology clinic in the region,
                recognized for our commitment to excellence, innovation, and patient
                satisfaction.
              </p>
            </div>

            <div>
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-3 sm:mb-4">
                Core Values 
              </h3>
              <ul className="space-y-2 sm:space-y-3 text-gray-600 text-justify">
                <li className="flex items-start sm:items-center">
                  <svg
                    className="w-5 h-5 text-[#FD5DA8] mr-2 mt-1 sm:mt-0 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span className="text-base sm:text-lg">Confidence, Redefined - More than just smiles and skin, we empower you to shine from within.</span>
                </li>
                <li className="flex items-start sm:items-center">
                  <svg
                    className="w-5 h-5 text-[#FD5DA8] mr-2 mt-1 sm:mt-0 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span className="text-base sm:text-lg">'Comfort-First' Approach - Advanced, pain-free treatments that make your journey stress-free and enjoyable.</span>
                </li>
                <li className="flex items-start sm:items-center">
                  <svg
                    className="w-5 h-5 text-[#FD5DA8] mr-2 mt-1 sm:mt-0 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span className="text-base sm:text-lg">Honesty & Integrity - We guide you with transparency, offering only what truly benefits you.</span>
                </li>
                <li className="flex items-start sm:items-center">
                  <svg
                    className="w-5 h-5 text-[#FD5DA8] mr-2 mt-1 sm:mt-0 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span className="text-base sm:text-lg">Enhancing, Not Altering - We highlight your best features with expert precision and care.</span>
                </li>
                <li className="flex items-start sm:items-center">
                  <svg
                    className="w-5 h-5 text-[#FD5DA8] mr-2 mt-1 sm:mt-0 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span className="text-base sm:text-lg">Beauty That Lasts - Our treatments are designed for results that stand the test of time, keeping you radiant for years to come.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 